/** Query-string keys for nation All Churches list scoping. */
export const CHURCH_LIST_URL_PARAMS = {
  DISTRICT_ID: 'districtId',
  DISTRICT_NAME: 'districtName',
} as const;
